<template>
  <div :class="wrapperClass">
    <AdvProgressBar
      :min="0"
      :max="transportThreshold"
      :current="cartTotal"
      progress-wrapper-class="minicart-progress-wrapper"
      progress-base-class="minicart-progress-base"
      progress-fill-class="minicart-progress-fill"
    >
      <div class="minicart-progress-logo-wrapper">
        <span class="minicart-progress-logo"></span>
      </div>
    </AdvProgressBar>
    <div class="alert-content text-black mt-3 mb-2 minicart-second-alert-content">
      <div v-if="isEligibleForFreeDelivery" class="minicart-free-delivery-eligible">
        <p>{{ t('congratulations', { namespace: 'advCartDeliveryInfo' }) }}</p>
        <p>{{ t('you_have_free_shipping', { namespace: 'advCartDeliveryInfo' }) }}</p>
      </div>
      <span v-else>{{ t('remaining_for_free_delivery', { namespace: 'advCartDeliveryInfo', params: [{remaining: remainingTotalForFreeDelivery, sign: currencySymbol}] }) }}</span>
    </div>
  </div>
</template>

<script>
import AdvProgressBar from './presentation/AdvProgressBar'

export default {
  name: 'AdvCartDeliveryInfo',
  components: {
    AdvProgressBar
  },
  props: {
    cartTotal: {
      type: [String, Number],
      default: 0
    },
    transportThreshold: {
      type: Number,
      default: 100
    },
    wrapperClass: {
      type: String,
      default: ''
    },
    currencySymbol: {
      type: String,
      default: ''
    }
  },
  computed: {
    isEligibleForFreeDelivery: function () {
      return this.cartTotal > this.transportThreshold
    },
    remainingTotalForFreeDelivery: function () {
      return (this.transportThreshold - this.cartTotal).toFixed(2)
    }
  }
}
</script>

<style lang="scss" scoped>
$prime1:#38f490;
$prime2:#F6F0E9;
$prime3:#3C3C3B;

.mini-cart-transport-message{
  background: white;
  padding: 0;
  margin-top:15px;
  color: black;
  font-size: 15px;
  line-height: 1.4;
  margin-bottom: 0;

  .minicart-second-alert-content{
    font-weight: 700;
    font-size: 12px;
    color: #EF4056;
  }

  .minicart-first-alert-content{
    padding-left: 10px;
    padding-right: 10px
  }
}
.minicart-free-delivery-eligible {
  p {
    margin: 0;
  }
}
</style>
